import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onMounted } from 'vue';
import { PaymentAPI } from '@/api/payment';
import { sendMetrics } from '@/utils/metrics';
import { EventType } from '@/types/event';
import { MetricTags } from '@/utils/tags';
import { trlMessage } from '@/services/i18n';
import { UiButton } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'pay-button',
    props: {
        ticketId: {},
        initPay: { type: Boolean, default: false },
        ticketType: { default: '' }
    },
    emits: ["success"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const loading = ref(false);
        const paymentParams = ref({});
        onMounted(() => {
            if (document.getElementById('cloudPayment')) {
                return;
            }
            const script = document.createElement('script');
            script.id = 'cloudPayment';
            script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js';
            script.async = true;
            document.body.appendChild(script);
            if (__props.initPay) {
                script.onload = initialPay;
            }
        });
        function initialPay() {
            loading.value = true;
            PaymentAPI.fetchPaymentInfo(__props.ticketId).then((resp) => {
                paymentParams.value = resp;
                payCloudpayments();
            });
        }
        function handleClick() {
            initialPay();
        }
        function payCloudpayments() {
            const widget = new window.cp.CloudPayments();
            const widgetProps = {
                ...paymentParams.value,
                skin: 'mini'
            };
            const type = EventType[__props.ticketType].toLowerCase();
            const ticketTypeTarget = MetricTags[type];
            sendMetrics(ticketTypeTarget);
            widget.pay('charge', widgetProps, {
                onSuccess: () => {
                    handleSuccess();
                },
                onFail: (reason, options) => {
                    console.error('CloudPayments:fail', reason, options);
                    handleError(reason);
                },
                onComplete: (paymentResult, options) => {
                    console.log('CloudPayments:complete', paymentResult, options);
                    handleComplete();
                }
            });
        }
        function handleSuccess() {
            loading.value = false;
            emit('success');
        }
        function handleComplete() {
            loading.value = false;
        }
        function handleError(message) {
            loading.value = false;
            console.log(message);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UiButton), {
                size: "l",
                onClick: handleClick,
                loading: loading.value
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(trlMessage)('pay.text')), 1)
                ]),
                _: 1
            }, 8, ["loading"]));
        };
    }
});
